import { Resize, IResizeOptions } from '@ifit/img/out/resize';
import { DefaultImages } from '@ifit/img/out/defaults';

export function getResizedImageUrl(url: string, defaultUrl: DefaultImages, options: IResizeOptions): string {
  const resize = new Resize();
  let sizedImageUrl;

  try {
    sizedImageUrl = resize.getUrl(url ?? defaultUrl, options);
  } catch (error) {
    sizedImageUrl = resize.getUrl(defaultUrl, options);
  }

  return sizedImageUrl;
}
